import { type InternalAxiosRequestConfig } from 'axios';

/**
 * Request interceptor that attaches the current app locale as Accept-Language.
 * Used by public (unauthenticated) axios instances so the backend
 * LocaleInterceptor can translate dynamic data without requiring auth.
 *
 * Works for any language stored in localStorage under "appLanguage"
 * (e.g. "en", "te", "hi") — no code changes needed when new languages are added.
 */
export const SetLanguageHeader = (
    config: InternalAxiosRequestConfig<any>
): InternalAxiosRequestConfig<any> => {
    const lang = localStorage.getItem('appLanguage') || 'en';
    config.headers['Accept-Language'] = lang;
    return config;
};
